import React from 'react';

import { getName } from 'helpers/fieldsHelpers';

export default function EventDescription (props) {
    const { openModalEvent, event: { project, organization, planedsotr, text, id }, openModalProject, openModalCompany } = props;

    return (
        <div className="calendar-event-main-information">
            <div className="calendar-event-name">
                <a onClick={() => openModalEvent({ id, value: text})}>{text}</a>
                <span> ({getName(planedsotr)})</span>
            </div>
            {project && (
                <a onClick={() => openModalProject(project[0])}>{getName(project)}</a>
            )}
            {organization && (
                <a onClick={()=> openModalCompany(organization[0])}>
                    <div>{getName(organization)}</div>
                </a>
            )}
        </div>
    );
}
